import path2regex from 'path-to-regexp';
import Loadable from 'react-loadable';

import Loading from '../containers/Loading';
import Login from '../../App/Visitante/Login/Login';
import { MinhasSolicitacoes, DetalhesSolicitacao, DetalhesInteracao } from '../../App/Solicitacoes';
import OAuth2RedirectHandler from '../../App/Visitante/Login/oauth2/OAuth2RedirectHandler';
import Logout from '../../App/Visitante/Logout/Logout';

const Onboarding = Loadable({
	loader: () => import('../containers/Onboarding'),
	loading: Loading
});

const Status404 = Loadable({
	loader: () => import('../containers/Status404'),
	loading: Loading
});

const TrocarSenha = Loadable({
	loader: () => import('../../App/Usuario/TrocarSenha/TrocarSenha'),
	loading: Loading
});

const LinkUser = Loadable({
	loader: () => import('../../App/Usuario/LinkUser'),
	loading: Loading
});

const EditarConta = Loadable({
	loader: () => import('../../App/Usuario/EditarConta/EditarConta'),
	loading: Loading
});

const CriarConta = Loadable({
	loader: () => import('../../App/Visitante/CriarConta/CriarConta'),
	loading: Loading
});

const RecuperarSenha = Loadable({
	loader: () => import('../../App/Visitante/RecuperarSenha/RecuperarSenha'),
	loading: Loading
});

const RedefinirSenha = Loadable({
	loader: () => import('../../App/Visitante/RedefinirSenha/RedefinirSenha'),
	loading: Loading
});

const ServicosDisponiveis = Loadable({
	loader: () => import('../../App/Servicos/ServicosDisponiveis'),
	loading: Loading
});

const FormularioServicos = Loadable({
	loader: () => import('../../App/Servicos/FormularioServico'),
	loading: Loading
});

const Ativacao = Loadable({
	loader: () => import('../../App/Visitante/Ativacao/Ativacao'),
	loading: Loading
});

const Configuracoes = Loadable({
	loader: () => import('../../App/Admin/Configuracao/Configuracoes'),
	loading: Loading
});

const Configuracao = Loadable({
	loader: () => import('../../App/Admin/Configuracao/Configuracao'),
	loading: Loading
});

const CadastroServico = Loadable({
	loader: () => import('../../App/Admin/Servico/CadastroServico'),
	loading: Loading
});

const ConsultaServicos = Loadable({
	loader: () => import('../../App/Admin/Servico/ConsultaServicos'),
	loading: Loading
});

const ConsultaUsuario = Loadable({
	loader: () => import('../../App/Admin/PerfilUsuario/ConsultaUsuario'),
	loading: Loading
});

const CadastroItemMenu = Loadable({
	loader: () => import('../../App/Admin/ItemMenu/CadastroItemMenu'),
	loading: Loading
});

const ConsultaItemMenu = Loadable({
	loader: () => import('../../App/Admin/ItemMenu/ConsultaItemMenu'),
	loading: Loading
});

const MyNotifications = Loadable({
	loader: () => import('App/Notifications'),
	loading: Loading
});

const DynamicMenu = Loadable({
	loader: () => import('../../App/AppLayout/containers/DynamicMenu'),
	loading: Loading
});

const DynamicRoutes = Loadable({
	loader: () => import('../../App/AppLayout/containers/DynamicRoutes'),
	loading: Loading
});

export const ROUTES = {
	ONBOARDING: {
		path: '/',
		component: Onboarding,
		isPrivate: false,
		exact: true
	},
	DETALHES_INTERACAO: {
		path: '/minhas-solicitacoes/:chaveSolicitacao(.+)/interacoes/:chaveInteracao(.+)',
		component: DetalhesInteracao,
		isPrivate: true,
		exact: true
	},
	DETALHES_SOLICITACAO: {
		path: '/minhas-solicitacoes/:chave(.+)',
		component: DetalhesSolicitacao,
		isPrivate: true,
		exact: true
	},
	MINHAS_SOLICITACOES: {
		path: '/minhas-solicitacoes',
		component: MinhasSolicitacoes,
		isPrivate: true,
		exact: true
	},
	EDITAR_CONTA: {
		path: '/editar-conta',
		component: EditarConta,
		isPrivate: true,
		exact: true
	},
	TROCAR_SENHA: {
		path: '/trocar-senha',
		component: TrocarSenha,
		isPrivate: true,
		exact: true
	},
	CONFIGURACOES: {
		path: '/admin/configuracoes',
		component: Configuracoes,
		isPrivate: true,
		exact: true,
		roles: ['ROLE_ADMIN']
	},
	CONFIGURACAO: {
		path: '/admin/configuracao/:chave([\\w\\.]+)',
		component: Configuracao,
		isPrivate: true,
		exact: true,
		roles: ['ROLE_ADMIN']
	},
	BUSCA_SERVICOS: {
		path: '/admin/servicos',
		component: ConsultaServicos,
		isPrivate: true,
		exact: true,
		roles: ['ROLE_ADMIN']
	},
	BUSCA_USUARIOS: {
		path: '/admin/perfilUsuario',
		component: ConsultaUsuario,
		isPrivate: true,
		exact: true,
		roles: ['ROLE_ADMIN']
	},
	NOVO_SERVICO: {
		path: '/admin/servicos/novo',
		component: CadastroServico,
		isPrivate: true,
		exact: true,
		roles: ['ROLE_ADMIN']
	},
	EDITAR_SERVICO: {
		path: '/admin/servicos/:codigo(\\d+)',
		component: CadastroServico,
		isPrivate: true,
		exact: true,
		roles: ['ROLE_ADMIN']
	},
	EDITAR_ITEMMENU: {
		path: '/admin/itemmenu/:codigo(\\d+)',
		component: CadastroItemMenu,
		isPrivate: true,
		exact: true,
		roles: ['ROLE_ADMIN']
	},
	BUSCA_ITENSMENU: {
		path: '/admin/itensmenu',
		component: ConsultaItemMenu,
		isPrivate: true,
		exact: true,
		roles: ['ROLE_ADMIN']
	},
	LINK_USER: {
		path: '/admin/linkUser',
		component: LinkUser,
		isPrivate: true,
		exact: true,
		roles: ['ROLE_CNPJ']
	},
	NOVO_ITEMMENU: {
		path: '/admin/itemmenu/novo',
		component: CadastroItemMenu,
		isPrivate: true,
		exact: true,
		roles: ['ROLE_ADMIN']
	},
	SERVICOS_DISPONIVEIS: {
		path: '/servicos-disponiveis',
		component: ServicosDisponiveis,
		isPrivate: false,
		exact: true
	},
	FORMULARIO_SERVICO: {
		path: '/formulario-servico/:codigo(\\d+)',
		component: FormularioServicos,
		isPrivate: false,
		exact: true
	},
	CRIAR_CONTA: {
		path: '/criar-conta',
		component: CriarConta,
		isPrivate: false,
		exact: true
	},
	RECUPERAR_SENHA: {
		path: '/recuperar-senha',
		component: RecuperarSenha,
		isPrivate: false,
		exact: true
	},
	REDEFINIR_SENHA: {
		path:
			'/redefinir-senha/:token([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})',
		component: RedefinirSenha,
		isPrivate: false,
		exact: true
	},
	LOGIN: {
		path: '/login',
		component: Login,
		isPrivate: false,
		exact: true
	},
	Ativacao: {
		path:
			'/ativacao/:token([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})',
		component: Ativacao,
		isPrivate: false,
		exact: true
	},
	MY_NOTIFICATIONS: {
		path: '/minhas-notificacoes',
		component: MyNotifications,
		isPrivate: true,
		exact: true
	},
	DYNAMIC_MENU: {
		path: '/dynamic-menu/:codigo(\\d+)',
		component: DynamicMenu,
		isPrivate: true,
		exact: true
	},
	DYNAMIC_MENU_FOO: {
		path: '/dynamic-menu-public/:codigo(\\d+)',
		component: DynamicMenu,
		isPrivate: false,
		exact: true
	},
	NOTIFICATION: {
		path: '/notification',
		component: DynamicRoutes,
		isPrivate: true,
		exact: true
	},
	OAUTH2_REDIRECT: {
		path: '/oauth2/redirect',
		component: OAuth2RedirectHandler,
		isPrivate: false,
		exact: true
	},
	LOGOUT: {
		path: '/logout',
		component: Logout,
		isPrivate: false,
		exact: true
	},
	STATUS_404: { component: Status404, isPrivate: false }
};

export const routeToPath = (route, prms) => {
	var toPath = path2regex.compile(route.path);
	return toPath(prms);
};